import React from "react";
import ArticleIcon from "@mui/icons-material/Article";
import ImageIcon from "@mui/icons-material/Image";
import VideoFileIcon from "@mui/icons-material/VideoFile";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import DescriptionIcon from "@mui/icons-material/Description";

export const fileIcons: { [key: string]: (props?: any) => JSX.Element } = {
  // Documentos
  ".txt": (props) => <ArticleIcon {...props} />,
  ".pdf": (props) => <ArticleIcon {...props} />,
  ".docx": (props) => <ArticleIcon {...props} />,
  ".doc": (props) => <ArticleIcon {...props} />,
  ".csv": (props) => <ArticleIcon {...props} />,
  ".xlsx": (props) => <ArticleIcon {...props} />,
  ".xls": (props) => <ArticleIcon {...props} />,
  ".ppt": (props) => <ArticleIcon {...props} />,
  ".pptx": (props) => <ArticleIcon {...props} />,
  ".odt": (props) => <ArticleIcon {...props} />,
  ".ods": (props) => <ArticleIcon {...props} />,
  ".odp": (props) => <ArticleIcon {...props} />,

  // Imagens
  ".jpg": (props) => <ImageIcon {...props} />,
  ".jpeg": (props) => <ImageIcon {...props} />,
  ".png": (props) => <ImageIcon {...props} />,
  ".gif": (props) => <ImageIcon {...props} />,
  ".bmp": (props) => <ImageIcon {...props} />,
  ".tiff": (props) => <ImageIcon {...props} />,
  ".svg": (props) => <ImageIcon {...props} />,
  ".heic": (props) => <ImageIcon {...props} />,
  ".webp": (props) => <ImageIcon {...props} />,

  // Vídeos
  ".mp4": (props) => <VideoFileIcon {...props} />,
  ".avi": (props) => <VideoFileIcon {...props} />,
  ".mkv": (props) => <VideoFileIcon {...props} />,
  ".mov": (props) => <VideoFileIcon {...props} />,
  ".wmv": (props) => <VideoFileIcon {...props} />,
  ".flv": (props) => <VideoFileIcon {...props} />,
  ".webm": (props) => <VideoFileIcon {...props} />,
  ".m4v": (props) => <VideoFileIcon {...props} />,

  // Áudios
  ".mp3": (props) => <AudioFileIcon {...props} />,
  ".wav": (props) => <AudioFileIcon {...props} />,
  ".aac": (props) => <AudioFileIcon {...props} />,
  ".ogg": (props) => <AudioFileIcon {...props} />,
  ".flac": (props) => <AudioFileIcon {...props} />,
  ".m4a": (props) => <AudioFileIcon {...props} />,
  ".wma": (props) => <AudioFileIcon {...props} />,

  // Compactados
  ".zip": (props) => <FolderZipIcon {...props} />,
  ".rar": (props) => <FolderZipIcon {...props} />,
  ".7z": (props) => <FolderZipIcon {...props} />,
  ".tar": (props) => <FolderZipIcon {...props} />,
  ".gz": (props) => <FolderZipIcon {...props} />,
  ".bz2": (props) => <FolderZipIcon {...props} />,
};

// Ícone genérico padrão
export const defaultIcon = (props?: any) => <DescriptionIcon {...props} />;
